export default {
  title: 'Additional invoice data',
  name: 'Name',
  value: 'Value'
}
